/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-63ed8f4f.js';
import '@carbon/icon-helpers';
import React from 'react';

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "19",
  cy: "19",
  r: "4"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
});

var WatsonHealthHoleFillingCursor32 = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFillingCursor32(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref2, _ref3, children);
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "19",
  cy: "19",
  r: "4"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
});

var WatsonHealthHoleFillingCursor24 = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFillingCursor24(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref5, _ref6, children);
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "19",
  cy: "19",
  r: "4"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
});

var WatsonHealthHoleFillingCursor20 = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFillingCursor20(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref8, _ref9, children);
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "19",
  cy: "19",
  r: "4"
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
});

var WatsonHealthHoleFillingCursor16 = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFillingCursor16(_ref10, ref) {
  var children = _ref10.children,
      rest = _objectWithoutProperties(_ref10, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref11, _ref12, children);
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
});

var Home32 = /*#__PURE__*/React.forwardRef(function Home32(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref14, children);
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
});

var Home24 = /*#__PURE__*/React.forwardRef(function Home24(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref16, children);
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
});

var Home20 = /*#__PURE__*/React.forwardRef(function Home20(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref18, children);
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
});

var Home16 = /*#__PURE__*/React.forwardRef(function Home16(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref20, children);
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
});

var _ref23 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
});

var Hospital32 = /*#__PURE__*/React.forwardRef(function Hospital32(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref22, _ref23, children);
});

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
});

var _ref26 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
});

var Hospital24 = /*#__PURE__*/React.forwardRef(function Hospital24(_ref24, ref) {
  var children = _ref24.children,
      rest = _objectWithoutProperties(_ref24, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref25, _ref26, children);
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
});

var _ref29 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
});

var Hospital20 = /*#__PURE__*/React.forwardRef(function Hospital20(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref28, _ref29, children);
});

var _ref31 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
});

var _ref32 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
});

var Hospital16 = /*#__PURE__*/React.forwardRef(function Hospital16(_ref30, ref) {
  var children = _ref30.children,
      rest = _objectWithoutProperties(_ref30, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref31, _ref32, children);
});

var _ref34 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
});

var _ref35 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
});

var HospitalBed32 = /*#__PURE__*/React.forwardRef(function HospitalBed32(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref34, _ref35, children);
});

var _ref37 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
});

var _ref38 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
});

var HospitalBed24 = /*#__PURE__*/React.forwardRef(function HospitalBed24(_ref36, ref) {
  var children = _ref36.children,
      rest = _objectWithoutProperties(_ref36, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref37, _ref38, children);
});

var _ref40 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
});

var _ref41 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
});

var HospitalBed20 = /*#__PURE__*/React.forwardRef(function HospitalBed20(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref40, _ref41, children);
});

var _ref43 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
});

var _ref44 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
});

var HospitalBed16 = /*#__PURE__*/React.forwardRef(function HospitalBed16(_ref42, ref) {
  var children = _ref42.children,
      rest = _objectWithoutProperties(_ref42, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref43, _ref44, children);
});

var _ref46 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
});

var _ref47 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
});

var Hotel32 = /*#__PURE__*/React.forwardRef(function Hotel32(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref46, _ref47, children);
});

var _ref49 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
});

var _ref50 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
});

var Hotel24 = /*#__PURE__*/React.forwardRef(function Hotel24(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref49, _ref50, children);
});

var _ref52 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
});

var _ref53 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
});

var Hotel20 = /*#__PURE__*/React.forwardRef(function Hotel20(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref52, _ref53, children);
});

var _ref55 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
});

var _ref56 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
});

var Hotel16 = /*#__PURE__*/React.forwardRef(function Hotel16(_ref54, ref) {
  var children = _ref54.children,
      rest = _objectWithoutProperties(_ref54, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref55, _ref56, children);
});

var _ref58 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 19H17V21H15zM15 23H17V25H15z"
});

var _ref59 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
});

var Hourglass32 = /*#__PURE__*/React.forwardRef(function Hourglass32(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref58, _ref59, children);
});

var _ref61 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 19H17V21H15zM15 23H17V25H15z"
});

var _ref62 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
});

var Hourglass24 = /*#__PURE__*/React.forwardRef(function Hourglass24(_ref60, ref) {
  var children = _ref60.children,
      rest = _objectWithoutProperties(_ref60, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref61, _ref62, children);
});

var _ref64 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 19H17V21H15zM15 23H17V25H15z"
});

var _ref65 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
});

var Hourglass20 = /*#__PURE__*/React.forwardRef(function Hourglass20(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref64, _ref65, children);
});

var _ref67 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 19H17V21H15zM15 23H17V25H15z"
});

var _ref68 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
});

var Hourglass16 = /*#__PURE__*/React.forwardRef(function Hourglass16(_ref66, ref) {
  var children = _ref66.children,
      rest = _objectWithoutProperties(_ref66, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref67, _ref68, children);
});

var _ref70 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
});

var Html32 = /*#__PURE__*/React.forwardRef(function Html32(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref70, children);
});

var _ref72 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
});

var Html24 = /*#__PURE__*/React.forwardRef(function Html24(_ref71, ref) {
  var children = _ref71.children,
      rest = _objectWithoutProperties(_ref71, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref72, children);
});

var _ref74 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
});

var Html20 = /*#__PURE__*/React.forwardRef(function Html20(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref74, children);
});

var _ref76 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
});

var Html16 = /*#__PURE__*/React.forwardRef(function Html16(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref76, children);
});

var _ref78 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
});

var HtmlReference32 = /*#__PURE__*/React.forwardRef(function HtmlReference32(_ref77, ref) {
  var children = _ref77.children,
      rest = _objectWithoutProperties(_ref77, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref78, children);
});

var _ref80 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
});

var HtmlReference24 = /*#__PURE__*/React.forwardRef(function HtmlReference24(_ref79, ref) {
  var children = _ref79.children,
      rest = _objectWithoutProperties(_ref79, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref80, children);
});

var _ref82 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
});

var HtmlReference20 = /*#__PURE__*/React.forwardRef(function HtmlReference20(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref82, children);
});

var _ref84 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
});

var HtmlReference16 = /*#__PURE__*/React.forwardRef(function HtmlReference16(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref84, children);
});

var _ref86 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
});

var Http32 = /*#__PURE__*/React.forwardRef(function Http32(_ref85, ref) {
  var children = _ref85.children,
      rest = _objectWithoutProperties(_ref85, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref86, children);
});

var _ref88 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
});

var Http24 = /*#__PURE__*/React.forwardRef(function Http24(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref88, children);
});

var _ref90 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
});

var Http20 = /*#__PURE__*/React.forwardRef(function Http20(_ref89, ref) {
  var children = _ref89.children,
      rest = _objectWithoutProperties(_ref89, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref90, children);
});

var _ref92 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
});

var Http16 = /*#__PURE__*/React.forwardRef(function Http16(_ref91, ref) {
  var children = _ref91.children,
      rest = _objectWithoutProperties(_ref91, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref92, children);
});

var _ref94 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
});

var Humidity32 = /*#__PURE__*/React.forwardRef(function Humidity32(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref94, children);
});

var _ref96 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
});

var Humidity24 = /*#__PURE__*/React.forwardRef(function Humidity24(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref96, children);
});

var _ref98 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
});

var Humidity20 = /*#__PURE__*/React.forwardRef(function Humidity20(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref98, children);
});

var _ref100 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
});

var Humidity16 = /*#__PURE__*/React.forwardRef(function Humidity16(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref100, children);
});

var _ref102 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
});

var HumidityAlt32 = /*#__PURE__*/React.forwardRef(function HumidityAlt32(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref102, children);
});

var _ref104 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
});

var HumidityAlt24 = /*#__PURE__*/React.forwardRef(function HumidityAlt24(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref104, children);
});

var _ref106 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
});

var HumidityAlt20 = /*#__PURE__*/React.forwardRef(function HumidityAlt20(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref106, children);
});

var _ref108 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
});

var HumidityAlt16 = /*#__PURE__*/React.forwardRef(function HumidityAlt16(_ref107, ref) {
  var children = _ref107.children,
      rest = _objectWithoutProperties(_ref107, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref108, children);
});

var _ref110 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
});

var Hurricane32 = /*#__PURE__*/React.forwardRef(function Hurricane32(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref110, children);
});

var _ref112 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
});

var Hurricane24 = /*#__PURE__*/React.forwardRef(function Hurricane24(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref112, children);
});

var _ref114 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
});

var Hurricane20 = /*#__PURE__*/React.forwardRef(function Hurricane20(_ref113, ref) {
  var children = _ref113.children,
      rest = _objectWithoutProperties(_ref113, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref114, children);
});

var _ref116 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
});

var Hurricane16 = /*#__PURE__*/React.forwardRef(function Hurricane16(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref116, children);
});

var _ref118 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z"
});

var _ref119 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z"
});

var _ref120 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z"
});

var HybridNetworking32 = /*#__PURE__*/React.forwardRef(function HybridNetworking32(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref118, _ref119, _ref120, children);
});

var _ref122 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z"
});

var _ref123 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z"
});

var _ref124 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z"
});

var HybridNetworking24 = /*#__PURE__*/React.forwardRef(function HybridNetworking24(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref122, _ref123, _ref124, children);
});

var _ref126 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z"
});

var _ref127 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z"
});

var _ref128 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z"
});

var HybridNetworking20 = /*#__PURE__*/React.forwardRef(function HybridNetworking20(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref126, _ref127, _ref128, children);
});

var _ref130 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z"
});

var _ref131 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z"
});

var _ref132 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z"
});

var HybridNetworking16 = /*#__PURE__*/React.forwardRef(function HybridNetworking16(_ref129, ref) {
  var children = _ref129.children,
      rest = _objectWithoutProperties(_ref129, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref130, _ref131, _ref132, children);
});

var _ref134 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
});

var IbmCloud32 = /*#__PURE__*/React.forwardRef(function IbmCloud32(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref134, children);
});

var _ref136 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
});

var IbmCloud24 = /*#__PURE__*/React.forwardRef(function IbmCloud24(_ref135, ref) {
  var children = _ref135.children,
      rest = _objectWithoutProperties(_ref135, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref136, children);
});

var _ref138 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
});

var IbmCloud20 = /*#__PURE__*/React.forwardRef(function IbmCloud20(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref138, children);
});

var _ref140 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
});

var IbmCloud16 = /*#__PURE__*/React.forwardRef(function IbmCloud16(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref140, children);
});

var _ref142 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
});

var IbmSecurity32 = /*#__PURE__*/React.forwardRef(function IbmSecurity32(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref142, children);
});

var _ref144 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
});

var IbmSecurity24 = /*#__PURE__*/React.forwardRef(function IbmSecurity24(_ref143, ref) {
  var children = _ref143.children,
      rest = _objectWithoutProperties(_ref143, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref144, children);
});

var _ref146 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
});

var IbmSecurity20 = /*#__PURE__*/React.forwardRef(function IbmSecurity20(_ref145, ref) {
  var children = _ref145.children,
      rest = _objectWithoutProperties(_ref145, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref146, children);
});

var _ref148 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
});

var IbmSecurity16 = /*#__PURE__*/React.forwardRef(function IbmSecurity16(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref148, children);
});

var _ref150 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2.001 21L2.001 30 11 30 11 28 4 28 4 21 2.001 21zM21.001 30L30 30 30 21 28.001 21 28.001 28 21.001 28 21.001 30zM22 24H10a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0027 2.0027 0 0122 24zM10 10V22H22.002L22 10zM30 11L30 2 21.001 2 21.001 4 28.001 4 28.001 11 30 11zM11 2L2.001 2 2.001 11 4 11 4 4 11 4 11 2z"
});

var WatsonHealthICa_2D32 = /*#__PURE__*/React.forwardRef(function WatsonHealthICa_2D32(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref150, children);
});

var _ref152 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2.001 21L2.001 30 11 30 11 28 4 28 4 21 2.001 21zM21.001 30L30 30 30 21 28.001 21 28.001 28 21.001 28 21.001 30zM22 24H10a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0027 2.0027 0 0122 24zM10 10V22H22.002L22 10zM30 11L30 2 21.001 2 21.001 4 28.001 4 28.001 11 30 11zM11 2L2.001 2 2.001 11 4 11 4 4 11 4 11 2z"
});

var WatsonHealthICa_2D24 = /*#__PURE__*/React.forwardRef(function WatsonHealthICa_2D24(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref152, children);
});

var _ref154 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2.001 21L2.001 30 11 30 11 28 4 28 4 21 2.001 21zM21.001 30L30 30 30 21 28.001 21 28.001 28 21.001 28 21.001 30zM22 24H10a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0027 2.0027 0 0122 24zM10 10V22H22.002L22 10zM30 11L30 2 21.001 2 21.001 4 28.001 4 28.001 11 30 11zM11 2L2.001 2 2.001 11 4 11 4 4 11 4 11 2z"
});

var WatsonHealthICa_2D20 = /*#__PURE__*/React.forwardRef(function WatsonHealthICa_2D20(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref154, children);
});

var _ref156 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2.001 21L2.001 30 11 30 11 28 4 28 4 21 2.001 21zM21.001 30L30 30 30 21 28.001 21 28.001 28 21.001 28 21.001 30zM22 24H10a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0027 2.0027 0 0122 24zM10 10V22H22.002L22 10zM30 11L30 2 21.001 2 21.001 4 28.001 4 28.001 11 30 11zM11 2L2.001 2 2.001 11 4 11 4 4 11 4 11 2z"
});

var WatsonHealthICa_2D16 = /*#__PURE__*/React.forwardRef(function WatsonHealthICa_2D16(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref156, children);
});

var _ref158 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
});

var _ref159 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
});

var IceAccretion32 = /*#__PURE__*/React.forwardRef(function IceAccretion32(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref158, _ref159, children);
});

var _ref161 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
});

var _ref162 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
});

var IceAccretion24 = /*#__PURE__*/React.forwardRef(function IceAccretion24(_ref160, ref) {
  var children = _ref160.children,
      rest = _objectWithoutProperties(_ref160, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref161, _ref162, children);
});

var _ref164 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
});

var _ref165 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
});

var IceAccretion20 = /*#__PURE__*/React.forwardRef(function IceAccretion20(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref164, _ref165, children);
});

var _ref167 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
});

var _ref168 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
});

var IceAccretion16 = /*#__PURE__*/React.forwardRef(function IceAccretion16(_ref166, ref) {
  var children = _ref166.children,
      rest = _objectWithoutProperties(_ref166, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref167, _ref168, children);
});

var _ref170 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
});

var QID32 = /*#__PURE__*/React.forwardRef(function QID32(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref170, children);
});

var _ref172 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
});

var QID24 = /*#__PURE__*/React.forwardRef(function QID24(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref172, children);
});

var _ref174 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
});

var QID20 = /*#__PURE__*/React.forwardRef(function QID20(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref174, children);
});

var _ref176 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
});

var QID16 = /*#__PURE__*/React.forwardRef(function QID16(_ref175, ref) {
  var children = _ref175.children,
      rest = _objectWithoutProperties(_ref175, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref176, children);
});

var _ref178 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
});

var Idea32 = /*#__PURE__*/React.forwardRef(function Idea32(_ref177, ref) {
  var children = _ref177.children,
      rest = _objectWithoutProperties(_ref177, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref178, children);
});

var _ref180 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
});

var Idea24 = /*#__PURE__*/React.forwardRef(function Idea24(_ref179, ref) {
  var children = _ref179.children,
      rest = _objectWithoutProperties(_ref179, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref180, children);
});

var _ref182 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
});

var Idea20 = /*#__PURE__*/React.forwardRef(function Idea20(_ref181, ref) {
  var children = _ref181.children,
      rest = _objectWithoutProperties(_ref181, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref182, children);
});

var _ref184 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
});

var Idea16 = /*#__PURE__*/React.forwardRef(function Idea16(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref184, children);
});

var _ref186 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
});

var _ref187 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
});

var Identification32 = /*#__PURE__*/React.forwardRef(function Identification32(_ref185, ref) {
  var children = _ref185.children,
      rest = _objectWithoutProperties(_ref185, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref186, _ref187, children);
});

var _ref189 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
});

var _ref190 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
});

var Identification24 = /*#__PURE__*/React.forwardRef(function Identification24(_ref188, ref) {
  var children = _ref188.children,
      rest = _objectWithoutProperties(_ref188, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref189, _ref190, children);
});

var _ref192 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
});

var _ref193 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
});

var Identification20 = /*#__PURE__*/React.forwardRef(function Identification20(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref192, _ref193, children);
});

var _ref195 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
});

var _ref196 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
});

var Identification16 = /*#__PURE__*/React.forwardRef(function Identification16(_ref194, ref) {
  var children = _ref194.children,
      rest = _objectWithoutProperties(_ref194, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref195, _ref196, children);
});

var _ref198 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
});

var _ref199 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
});

var Image32 = /*#__PURE__*/React.forwardRef(function Image32(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref198, _ref199, children);
});

var _ref201 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
});

var _ref202 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
});

var Image24 = /*#__PURE__*/React.forwardRef(function Image24(_ref200, ref) {
  var children = _ref200.children,
      rest = _objectWithoutProperties(_ref200, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref201, _ref202, children);
});

var _ref204 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
});

var _ref205 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
});

var Image20 = /*#__PURE__*/React.forwardRef(function Image20(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref204, _ref205, children);
});

var _ref207 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
});

var _ref208 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
});

var Image16 = /*#__PURE__*/React.forwardRef(function Image16(_ref206, ref) {
  var children = _ref206.children,
      rest = _objectWithoutProperties(_ref206, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref207, _ref208, children);
});

var _ref210 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
});

var _ref211 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
});

var ImageMedical32 = /*#__PURE__*/React.forwardRef(function ImageMedical32(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref210, _ref211, children);
});

var _ref213 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
});

var _ref214 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
});

var ImageMedical24 = /*#__PURE__*/React.forwardRef(function ImageMedical24(_ref212, ref) {
  var children = _ref212.children,
      rest = _objectWithoutProperties(_ref212, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref213, _ref214, children);
});

var _ref216 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
});

var _ref217 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
});

var ImageMedical20 = /*#__PURE__*/React.forwardRef(function ImageMedical20(_ref215, ref) {
  var children = _ref215.children,
      rest = _objectWithoutProperties(_ref215, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref216, _ref217, children);
});

var _ref219 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
});

var _ref220 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
});

var ImageMedical16 = /*#__PURE__*/React.forwardRef(function ImageMedical16(_ref218, ref) {
  var children = _ref218.children,
      rest = _objectWithoutProperties(_ref218, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref219, _ref220, children);
});

var _ref222 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
});

var _ref223 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
});

var ImageReference32 = /*#__PURE__*/React.forwardRef(function ImageReference32(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref222, _ref223, children);
});

var _ref225 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
});

var _ref226 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
});

var ImageReference24 = /*#__PURE__*/React.forwardRef(function ImageReference24(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref225, _ref226, children);
});

var _ref228 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
});

var _ref229 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
});

var ImageReference20 = /*#__PURE__*/React.forwardRef(function ImageReference20(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref228, _ref229, children);
});

var _ref231 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
});

var _ref232 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
});

var ImageReference16 = /*#__PURE__*/React.forwardRef(function ImageReference16(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref231, _ref232, children);
});

var _ref234 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
});

var _ref235 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
});

var ImageSearch32 = /*#__PURE__*/React.forwardRef(function ImageSearch32(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref234, _ref235, children);
});

var _ref237 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
});

var _ref238 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
});

var ImageSearch24 = /*#__PURE__*/React.forwardRef(function ImageSearch24(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref237, _ref238, children);
});

var _ref240 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
});

var _ref241 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
});

var ImageSearch20 = /*#__PURE__*/React.forwardRef(function ImageSearch20(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref240, _ref241, children);
});

var _ref243 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
});

var _ref244 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
});

var ImageSearch16 = /*#__PURE__*/React.forwardRef(function ImageSearch16(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref243, _ref244, children);
});

var _ref246 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z"
});

var _ref247 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2"
});

var _ref248 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
});

var _ref249 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z"
});

var ImproveRelevance32 = /*#__PURE__*/React.forwardRef(function ImproveRelevance32(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref246, _ref247, _ref248, _ref249, children);
});

var _ref251 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z"
});

var _ref252 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2"
});

var _ref253 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
});

var _ref254 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z"
});

var ImproveRelevance24 = /*#__PURE__*/React.forwardRef(function ImproveRelevance24(_ref250, ref) {
  var children = _ref250.children,
      rest = _objectWithoutProperties(_ref250, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref251, _ref252, _ref253, _ref254, children);
});

var _ref256 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z"
});

var _ref257 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2"
});

var _ref258 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
});

var _ref259 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z"
});

var ImproveRelevance20 = /*#__PURE__*/React.forwardRef(function ImproveRelevance20(_ref255, ref) {
  var children = _ref255.children,
      rest = _objectWithoutProperties(_ref255, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref256, _ref257, _ref258, _ref259, children);
});

var _ref261 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z"
});

var _ref262 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2"
});

var _ref263 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
});

var _ref264 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z"
});

var ImproveRelevance16 = /*#__PURE__*/React.forwardRef(function ImproveRelevance16(_ref260, ref) {
  var children = _ref260.children,
      rest = _objectWithoutProperties(_ref260, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref261, _ref262, _ref263, _ref264, children);
});

var _ref266 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z"
});

var InProgress32 = /*#__PURE__*/React.forwardRef(function InProgress32(_ref265, ref) {
  var children = _ref265.children,
      rest = _objectWithoutProperties(_ref265, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref266, children);
});

var _ref268 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z"
});

var InProgress24 = /*#__PURE__*/React.forwardRef(function InProgress24(_ref267, ref) {
  var children = _ref267.children,
      rest = _objectWithoutProperties(_ref267, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref268, children);
});

var _ref270 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z"
});

var InProgress20 = /*#__PURE__*/React.forwardRef(function InProgress20(_ref269, ref) {
  var children = _ref269.children,
      rest = _objectWithoutProperties(_ref269, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref270, children);
});

var _ref272 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z"
});

var InProgress16 = /*#__PURE__*/React.forwardRef(function InProgress16(_ref271, ref) {
  var children = _ref271.children,
      rest = _objectWithoutProperties(_ref271, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref272, children);
});

var _ref274 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
});

var _ref275 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z"
});

var InProgressError32 = /*#__PURE__*/React.forwardRef(function InProgressError32(_ref273, ref) {
  var children = _ref273.children,
      rest = _objectWithoutProperties(_ref273, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref274, _ref275, children);
});

var _ref277 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
});

var _ref278 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z"
});

var InProgressError24 = /*#__PURE__*/React.forwardRef(function InProgressError24(_ref276, ref) {
  var children = _ref276.children,
      rest = _objectWithoutProperties(_ref276, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref277, _ref278, children);
});

var _ref280 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
});

var _ref281 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z"
});

var InProgressError20 = /*#__PURE__*/React.forwardRef(function InProgressError20(_ref279, ref) {
  var children = _ref279.children,
      rest = _objectWithoutProperties(_ref279, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref280, _ref281, children);
});

var _ref283 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
});

var _ref284 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z"
});

var InProgressError16 = /*#__PURE__*/React.forwardRef(function InProgressError16(_ref282, ref) {
  var children = _ref282.children,
      rest = _objectWithoutProperties(_ref282, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref283, _ref284, children);
});

var _ref286 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
});

var _ref287 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z"
});

var InProgressWarning32 = /*#__PURE__*/React.forwardRef(function InProgressWarning32(_ref285, ref) {
  var children = _ref285.children,
      rest = _objectWithoutProperties(_ref285, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref286, _ref287, children);
});

var _ref289 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
});

var _ref290 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z"
});

var InProgressWarning24 = /*#__PURE__*/React.forwardRef(function InProgressWarning24(_ref288, ref) {
  var children = _ref288.children,
      rest = _objectWithoutProperties(_ref288, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref289, _ref290, children);
});

var _ref292 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
});

var _ref293 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z"
});

var InProgressWarning20 = /*#__PURE__*/React.forwardRef(function InProgressWarning20(_ref291, ref) {
  var children = _ref291.children,
      rest = _objectWithoutProperties(_ref291, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref292, _ref293, children);
});

var _ref295 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
});

var _ref296 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z"
});

var InProgressWarning16 = /*#__PURE__*/React.forwardRef(function InProgressWarning16(_ref294, ref) {
  var children = _ref294.children,
      rest = _objectWithoutProperties(_ref294, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref295, _ref296, children);
});

var _ref298 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z"
});

var Incomplete32 = /*#__PURE__*/React.forwardRef(function Incomplete32(_ref297, ref) {
  var children = _ref297.children,
      rest = _objectWithoutProperties(_ref297, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref298, children);
});

var _ref300 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z"
});

var Incomplete24 = /*#__PURE__*/React.forwardRef(function Incomplete24(_ref299, ref) {
  var children = _ref299.children,
      rest = _objectWithoutProperties(_ref299, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref300, children);
});

var _ref302 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z"
});

var Incomplete20 = /*#__PURE__*/React.forwardRef(function Incomplete20(_ref301, ref) {
  var children = _ref301.children,
      rest = _objectWithoutProperties(_ref301, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref302, children);
});

var _ref304 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z"
});

var Incomplete16 = /*#__PURE__*/React.forwardRef(function Incomplete16(_ref303, ref) {
  var children = _ref303.children,
      rest = _objectWithoutProperties(_ref303, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref304, children);
});

var _ref306 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41zM14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14z"
});

var IncompleteCancel32 = /*#__PURE__*/React.forwardRef(function IncompleteCancel32(_ref305, ref) {
  var children = _ref305.children,
      rest = _objectWithoutProperties(_ref305, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref306, children);
});

var _ref308 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41zM14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14z"
});

var IncompleteCancel24 = /*#__PURE__*/React.forwardRef(function IncompleteCancel24(_ref307, ref) {
  var children = _ref307.children,
      rest = _objectWithoutProperties(_ref307, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref308, children);
});

var _ref310 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41zM14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14z"
});

var IncompleteCancel20 = /*#__PURE__*/React.forwardRef(function IncompleteCancel20(_ref309, ref) {
  var children = _ref309.children,
      rest = _objectWithoutProperties(_ref309, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref310, children);
});

var _ref312 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41zM14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14z"
});

var IncompleteCancel16 = /*#__PURE__*/React.forwardRef(function IncompleteCancel16(_ref311, ref) {
  var children = _ref311.children,
      rest = _objectWithoutProperties(_ref311, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref312, children);
});

var _ref314 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
});

var IncompleteError32 = /*#__PURE__*/React.forwardRef(function IncompleteError32(_ref313, ref) {
  var children = _ref313.children,
      rest = _objectWithoutProperties(_ref313, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref314, children);
});

var _ref316 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
});

var IncompleteError24 = /*#__PURE__*/React.forwardRef(function IncompleteError24(_ref315, ref) {
  var children = _ref315.children,
      rest = _objectWithoutProperties(_ref315, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref316, children);
});

var _ref318 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
});

var IncompleteError20 = /*#__PURE__*/React.forwardRef(function IncompleteError20(_ref317, ref) {
  var children = _ref317.children,
      rest = _objectWithoutProperties(_ref317, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref318, children);
});

var _ref320 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
});

var IncompleteError16 = /*#__PURE__*/React.forwardRef(function IncompleteError16(_ref319, ref) {
  var children = _ref319.children,
      rest = _objectWithoutProperties(_ref319, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref320, children);
});

var _ref322 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
});

var IncompleteWarning32 = /*#__PURE__*/React.forwardRef(function IncompleteWarning32(_ref321, ref) {
  var children = _ref321.children,
      rest = _objectWithoutProperties(_ref321, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref322, children);
});

var _ref324 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
});

var IncompleteWarning24 = /*#__PURE__*/React.forwardRef(function IncompleteWarning24(_ref323, ref) {
  var children = _ref323.children,
      rest = _objectWithoutProperties(_ref323, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref324, children);
});

var _ref326 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
});

var IncompleteWarning20 = /*#__PURE__*/React.forwardRef(function IncompleteWarning20(_ref325, ref) {
  var children = _ref325.children,
      rest = _objectWithoutProperties(_ref325, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref326, children);
});

var _ref328 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
});

var IncompleteWarning16 = /*#__PURE__*/React.forwardRef(function IncompleteWarning16(_ref327, ref) {
  var children = _ref327.children,
      rest = _objectWithoutProperties(_ref327, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref328, children);
});

var _ref330 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z"
});

var IncreaseLevel32 = /*#__PURE__*/React.forwardRef(function IncreaseLevel32(_ref329, ref) {
  var children = _ref329.children,
      rest = _objectWithoutProperties(_ref329, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref330, children);
});

var _ref332 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z"
});

var IncreaseLevel24 = /*#__PURE__*/React.forwardRef(function IncreaseLevel24(_ref331, ref) {
  var children = _ref331.children,
      rest = _objectWithoutProperties(_ref331, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref332, children);
});

var _ref334 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z"
});

var IncreaseLevel20 = /*#__PURE__*/React.forwardRef(function IncreaseLevel20(_ref333, ref) {
  var children = _ref333.children,
      rest = _objectWithoutProperties(_ref333, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref334, children);
});

var _ref336 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z"
});

var IncreaseLevel16 = /*#__PURE__*/React.forwardRef(function IncreaseLevel16(_ref335, ref) {
  var children = _ref335.children,
      rest = _objectWithoutProperties(_ref335, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref336, children);
});

var _ref338 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z"
});

var Industry32 = /*#__PURE__*/React.forwardRef(function Industry32(_ref337, ref) {
  var children = _ref337.children,
      rest = _objectWithoutProperties(_ref337, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref338, children);
});

var _ref340 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z"
});

var Industry24 = /*#__PURE__*/React.forwardRef(function Industry24(_ref339, ref) {
  var children = _ref339.children,
      rest = _objectWithoutProperties(_ref339, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref340, children);
});

var _ref342 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z"
});

var Industry20 = /*#__PURE__*/React.forwardRef(function Industry20(_ref341, ref) {
  var children = _ref341.children,
      rest = _objectWithoutProperties(_ref341, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref342, children);
});

var _ref344 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z"
});

var Industry16 = /*#__PURE__*/React.forwardRef(function Industry16(_ref343, ref) {
  var children = _ref343.children,
      rest = _objectWithoutProperties(_ref343, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref344, children);
});

var _ref346 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
});

var _ref347 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
});

var Information32 = /*#__PURE__*/React.forwardRef(function Information32(_ref345, ref) {
  var children = _ref345.children,
      rest = _objectWithoutProperties(_ref345, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref346, _ref347, children);
});

var _ref349 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
});

var _ref350 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
});

var Information24 = /*#__PURE__*/React.forwardRef(function Information24(_ref348, ref) {
  var children = _ref348.children,
      rest = _objectWithoutProperties(_ref348, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref349, _ref350, children);
});

var _ref352 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
});

var _ref353 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
});

var Information20 = /*#__PURE__*/React.forwardRef(function Information20(_ref351, ref) {
  var children = _ref351.children,
      rest = _objectWithoutProperties(_ref351, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref352, _ref353, children);
});

var _ref355 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.5 11L8.5 6.5 6.5 6.5 6.5 7.5 7.5 7.5 7.5 11 6 11 6 12 10 12 10 11zM8 3.5c-.4 0-.8.3-.8.8S7.6 5 8 5c.4 0 .8-.3.8-.8S8.4 3.5 8 3.5z"
});

var _ref356 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,15c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S11.9,15,8,15z M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z"
});

var Information16 = /*#__PURE__*/React.forwardRef(function Information16(_ref354, ref) {
  var children = _ref354.children,
      rest = _objectWithoutProperties(_ref354, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref355, _ref356, children);
});

var _ref358 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z"
});

var _ref359 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
});

var InformationFilled32 = /*#__PURE__*/React.forwardRef(function InformationFilled32(_ref357, ref) {
  var children = _ref357.children,
      rest = _objectWithoutProperties(_ref357, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref358, _ref359, children);
});

var _ref361 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z"
});

var _ref362 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
});

var InformationFilled24 = /*#__PURE__*/React.forwardRef(function InformationFilled24(_ref360, ref) {
  var children = _ref360.children,
      rest = _objectWithoutProperties(_ref360, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref361, _ref362, children);
});

var _ref364 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z"
});

var _ref365 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
});

var InformationFilled20 = /*#__PURE__*/React.forwardRef(function InformationFilled20(_ref363, ref) {
  var children = _ref363.children,
      rest = _objectWithoutProperties(_ref363, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref364, _ref365, children);
});

var _ref367 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z"
});

var _ref368 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
});

var InformationFilled16 = /*#__PURE__*/React.forwardRef(function InformationFilled16(_ref366, ref) {
  var children = _ref366.children,
      rest = _objectWithoutProperties(_ref366, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref367, _ref368, children);
});

var _ref370 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
});

var _ref371 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z"
});

var InformationSquare32 = /*#__PURE__*/React.forwardRef(function InformationSquare32(_ref369, ref) {
  var children = _ref369.children,
      rest = _objectWithoutProperties(_ref369, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref370, _ref371, children);
});

var _ref373 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
});

var _ref374 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z"
});

var InformationSquare24 = /*#__PURE__*/React.forwardRef(function InformationSquare24(_ref372, ref) {
  var children = _ref372.children,
      rest = _objectWithoutProperties(_ref372, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref373, _ref374, children);
});

var _ref376 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
});

var _ref377 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z"
});

var InformationSquare20 = /*#__PURE__*/React.forwardRef(function InformationSquare20(_ref375, ref) {
  var children = _ref375.children,
      rest = _objectWithoutProperties(_ref375, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref376, _ref377, children);
});

var _ref379 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
});

var _ref380 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z"
});

var InformationSquare16 = /*#__PURE__*/React.forwardRef(function InformationSquare16(_ref378, ref) {
  var children = _ref378.children,
      rest = _objectWithoutProperties(_ref378, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref379, _ref380, children);
});

var _ref382 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z"
});

var _ref383 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
});

var InformationSquareFilled32 = /*#__PURE__*/React.forwardRef(function InformationSquareFilled32(_ref381, ref) {
  var children = _ref381.children,
      rest = _objectWithoutProperties(_ref381, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref382, _ref383, children);
});

var _ref385 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z"
});

var _ref386 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
});

var InformationSquareFilled24 = /*#__PURE__*/React.forwardRef(function InformationSquareFilled24(_ref384, ref) {
  var children = _ref384.children,
      rest = _objectWithoutProperties(_ref384, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref385, _ref386, children);
});

var _ref388 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z"
});

var _ref389 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
});

var InformationSquareFilled20 = /*#__PURE__*/React.forwardRef(function InformationSquareFilled20(_ref387, ref) {
  var children = _ref387.children,
      rest = _objectWithoutProperties(_ref387, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref388, _ref389, children);
});

var _ref391 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z"
});

var _ref392 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
});

var InformationSquareFilled16 = /*#__PURE__*/React.forwardRef(function InformationSquareFilled16(_ref390, ref) {
  var children = _ref390.children,
      rest = _objectWithoutProperties(_ref390, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref391, _ref392, children);
});

var _ref394 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 9h9V2H2zM4 4H9V7H4zM2 19h9V12H2zm2-5H9v3H4zM2 29h9V22H2zm2-5H9v3H4zM27 9H18l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 011 1V24a1 1 0 01-1 1H15v2H27a3 3 0 003-3V12A3 3 0 0027 9z"
});

var Insert32 = /*#__PURE__*/React.forwardRef(function Insert32(_ref393, ref) {
  var children = _ref393.children,
      rest = _objectWithoutProperties(_ref393, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref394, children);
});

var _ref396 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 9h9V2H2zM4 4H9V7H4zM2 19h9V12H2zm2-5H9v3H4zM2 29h9V22H2zm2-5H9v3H4zM27 9H18l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 011 1V24a1 1 0 01-1 1H15v2H27a3 3 0 003-3V12A3 3 0 0027 9z"
});

var Insert24 = /*#__PURE__*/React.forwardRef(function Insert24(_ref395, ref) {
  var children = _ref395.children,
      rest = _objectWithoutProperties(_ref395, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref396, children);
});

var _ref398 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 9h9V2H2zM4 4H9V7H4zM2 19h9V12H2zm2-5H9v3H4zM2 29h9V22H2zm2-5H9v3H4zM27 9H18l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 011 1V24a1 1 0 01-1 1H15v2H27a3 3 0 003-3V12A3 3 0 0027 9z"
});

var Insert20 = /*#__PURE__*/React.forwardRef(function Insert20(_ref397, ref) {
  var children = _ref397.children,
      rest = _objectWithoutProperties(_ref397, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref398, children);
});

var _ref400 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 9h9V2H2zM4 4H9V7H4zM2 19h9V12H2zm2-5H9v3H4zM2 29h9V22H2zm2-5H9v3H4zM27 9H18l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 011 1V24a1 1 0 01-1 1H15v2H27a3 3 0 003-3V12A3 3 0 0027 9z"
});

var Insert16 = /*#__PURE__*/React.forwardRef(function Insert16(_ref399, ref) {
  var children = _ref399.children,
      rest = _objectWithoutProperties(_ref399, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref400, children);
});

var _ref402 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 30H24V20H12V30H10V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2zM5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16zM24 14H12a2.0021 2.0021 0 01-2-2V2h2V12H24V2h2V12A2.0021 2.0021 0 0124 14z"
});

var InsertPage32 = /*#__PURE__*/React.forwardRef(function InsertPage32(_ref401, ref) {
  var children = _ref401.children,
      rest = _objectWithoutProperties(_ref401, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref402, children);
});

var _ref404 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 30H24V20H12V30H10V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2zM5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16zM24 14H12a2.0021 2.0021 0 01-2-2V2h2V12H24V2h2V12A2.0021 2.0021 0 0124 14z"
});

var InsertPage24 = /*#__PURE__*/React.forwardRef(function InsertPage24(_ref403, ref) {
  var children = _ref403.children,
      rest = _objectWithoutProperties(_ref403, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref404, children);
});

var _ref406 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 30H24V20H12V30H10V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2zM5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16zM24 14H12a2.0021 2.0021 0 01-2-2V2h2V12H24V2h2V12A2.0021 2.0021 0 0124 14z"
});

var InsertPage20 = /*#__PURE__*/React.forwardRef(function InsertPage20(_ref405, ref) {
  var children = _ref405.children,
      rest = _objectWithoutProperties(_ref405, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref406, children);
});

var _ref408 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 30H24V20H12V30H10V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2zM5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16zM24 14H12a2.0021 2.0021 0 01-2-2V2h2V12H24V2h2V12A2.0021 2.0021 0 0124 14z"
});

var InsertPage16 = /*#__PURE__*/React.forwardRef(function InsertPage16(_ref407, ref) {
  var children = _ref407.children,
      rest = _objectWithoutProperties(_ref407, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref408, children);
});

var _ref410 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z"
});

var Integration32 = /*#__PURE__*/React.forwardRef(function Integration32(_ref409, ref) {
  var children = _ref409.children,
      rest = _objectWithoutProperties(_ref409, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref410, children);
});

var _ref412 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z"
});

var Integration24 = /*#__PURE__*/React.forwardRef(function Integration24(_ref411, ref) {
  var children = _ref411.children,
      rest = _objectWithoutProperties(_ref411, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref412, children);
});

var _ref414 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z"
});

var Integration20 = /*#__PURE__*/React.forwardRef(function Integration20(_ref413, ref) {
  var children = _ref413.children,
      rest = _objectWithoutProperties(_ref413, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref414, children);
});

var _ref416 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z"
});

var Integration16 = /*#__PURE__*/React.forwardRef(function Integration16(_ref415, ref) {
  var children = _ref415.children,
      rest = _objectWithoutProperties(_ref415, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref416, children);
});

var _ref418 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 18H22V14H20V28h6a2.0027 2.0027 0 002-2V20A2.0023 2.0023 0 0026 18zm-4 8V20h4v6zM20 6.076L19.256 4.219 16 5.522 16 2 14 2 14 5.523 10.744 4.22 10 6.077 13.417 7.444 10.9 10.8 12.5 12 15 8.667 17.5 12 19.1 10.8 16.583 7.443 20 6.076zM10 18H5v2h5v2H6a2 2 0 00-2 2v2a2 2 0 002 2h6V20A2.0023 2.0023 0 0010 18zm0 8H6V24h4z"
});

var Interactions32 = /*#__PURE__*/React.forwardRef(function Interactions32(_ref417, ref) {
  var children = _ref417.children,
      rest = _objectWithoutProperties(_ref417, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref418, children);
});

var _ref420 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 18H22V14H20V28h6a2.0027 2.0027 0 002-2V20A2.0023 2.0023 0 0026 18zm-4 8V20h4v6zM20 6.076L19.256 4.219 16 5.522 16 2 14 2 14 5.523 10.744 4.22 10 6.077 13.417 7.444 10.9 10.8 12.5 12 15 8.667 17.5 12 19.1 10.8 16.583 7.443 20 6.076zM10 18H5v2h5v2H6a2 2 0 00-2 2v2a2 2 0 002 2h6V20A2.0023 2.0023 0 0010 18zm0 8H6V24h4z"
});

var Interactions24 = /*#__PURE__*/React.forwardRef(function Interactions24(_ref419, ref) {
  var children = _ref419.children,
      rest = _objectWithoutProperties(_ref419, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref420, children);
});

var _ref422 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 18H22V14H20V28h6a2.0027 2.0027 0 002-2V20A2.0023 2.0023 0 0026 18zm-4 8V20h4v6zM20 6.076L19.256 4.219 16 5.522 16 2 14 2 14 5.523 10.744 4.22 10 6.077 13.417 7.444 10.9 10.8 12.5 12 15 8.667 17.5 12 19.1 10.8 16.583 7.443 20 6.076zM10 18H5v2h5v2H6a2 2 0 00-2 2v2a2 2 0 002 2h6V20A2.0023 2.0023 0 0010 18zm0 8H6V24h4z"
});

var Interactions20 = /*#__PURE__*/React.forwardRef(function Interactions20(_ref421, ref) {
  var children = _ref421.children,
      rest = _objectWithoutProperties(_ref421, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref422, children);
});

var _ref424 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M11,7 L11,9 L13,9 C13.5522847,9 14,9.44771525 14,10 L14,10 L14,13 C14,13.5522847 13.5522847,14 13,14 L13,14 L10,14 L10,7 L11,7 Z M5,9 C5.55228475,9 6,9.44771525 6,10 L6,10 L6,14 L3,14 C2.44771525,14 2,13.5522847 2,13 L2,13 L2,12 C2,11.4477153 2.44771525,11 3,11 L3,11 L5,11 L5,10 L2.5,10 L2.5,9 Z M13,10 L11,10 L11,13 L13,13 L13,10 Z M5,12 L3,12 L3,13 L5,13 L5,12 Z M7.912,2 L7.834,3.911 L9.628,3.248 L9.914,4.119 L8.068,4.626 L9.251,6.134 L8.523,6.667 L7.457,5.068 L6.391,6.667 L5.663,6.134 L6.846,4.626 L5,4.119 L5.286,3.248 L7.08,3.911 L7.002,2 L7.912,2 Z"
});

var Interactions16 = /*#__PURE__*/React.forwardRef(function Interactions16(_ref423, ref) {
  var children = _ref423.children,
      rest = _objectWithoutProperties(_ref423, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref424, children);
});

var _ref426 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z"
});

var _ref427 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.586 18.586H10.414V21.413999999999998H7.586z",
  transform: "rotate(-45 9 20)"
});

var _ref428 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.586 7.586H21.413999999999998V10.414H18.586z",
  transform: "rotate(-45 20 9)"
});

var _ref429 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.586 7.586H10.414V10.414H7.586z",
  transform: "rotate(-45 9 9)"
});

var _ref430 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
});

var WatsonHealthInteractiveSegmentationCursor32 = /*#__PURE__*/React.forwardRef(function WatsonHealthInteractiveSegmentationCursor32(_ref425, ref) {
  var children = _ref425.children,
      rest = _objectWithoutProperties(_ref425, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref426, _ref427, _ref428, _ref429, _ref430, children);
});

var _ref432 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z"
});

var _ref433 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.586 18.586H10.414V21.413999999999998H7.586z",
  transform: "rotate(-45 9 20)"
});

var _ref434 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.586 7.586H21.413999999999998V10.414H18.586z",
  transform: "rotate(-45 20 9)"
});

var _ref435 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.586 7.586H10.414V10.414H7.586z",
  transform: "rotate(-45 9 9)"
});

var _ref436 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
});

var WatsonHealthInteractiveSegmentationCursor24 = /*#__PURE__*/React.forwardRef(function WatsonHealthInteractiveSegmentationCursor24(_ref431, ref) {
  var children = _ref431.children,
      rest = _objectWithoutProperties(_ref431, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref432, _ref433, _ref434, _ref435, _ref436, children);
});

var _ref438 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z"
});

var _ref439 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.586 18.586H10.414V21.413999999999998H7.586z",
  transform: "rotate(-45 9 20)"
});

var _ref440 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.586 7.586H21.413999999999998V10.414H18.586z",
  transform: "rotate(-45 20 9)"
});

var _ref441 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.586 7.586H10.414V10.414H7.586z",
  transform: "rotate(-45 9 9)"
});

var _ref442 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
});

var WatsonHealthInteractiveSegmentationCursor20 = /*#__PURE__*/React.forwardRef(function WatsonHealthInteractiveSegmentationCursor20(_ref437, ref) {
  var children = _ref437.children,
      rest = _objectWithoutProperties(_ref437, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref438, _ref439, _ref440, _ref441, _ref442, children);
});

var _ref444 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z"
});

var _ref445 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.586 18.586H10.414V21.413999999999998H7.586z",
  transform: "rotate(-45 9 20)"
});

var _ref446 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.586 7.586H21.413999999999998V10.414H18.586z",
  transform: "rotate(-45 20 9)"
});

var _ref447 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.586 7.586H10.414V10.414H7.586z",
  transform: "rotate(-45 9 9)"
});

var _ref448 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
});

var WatsonHealthInteractiveSegmentationCursor16 = /*#__PURE__*/React.forwardRef(function WatsonHealthInteractiveSegmentationCursor16(_ref443, ref) {
  var children = _ref443.children,
      rest = _objectWithoutProperties(_ref443, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref444, _ref445, _ref446, _ref447, _ref448, children);
});

var _ref450 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 24H18V22h4V18h2v4A2.0021 2.0021 0 0122 24zM10 14H8V10a2.0022 2.0022 0 012-2h4v2H10z"
});

var _ref451 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z"
});

var Intersect32 = /*#__PURE__*/React.forwardRef(function Intersect32(_ref449, ref) {
  var children = _ref449.children,
      rest = _objectWithoutProperties(_ref449, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref450, _ref451, children);
});

var _ref453 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 24H18V22h4V18h2v4A2.0021 2.0021 0 0122 24zM10 14H8V10a2.0022 2.0022 0 012-2h4v2H10z"
});

var _ref454 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z"
});

var Intersect24 = /*#__PURE__*/React.forwardRef(function Intersect24(_ref452, ref) {
  var children = _ref452.children,
      rest = _objectWithoutProperties(_ref452, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref453, _ref454, children);
});

var _ref456 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 24H18V22h4V18h2v4A2.0021 2.0021 0 0122 24zM10 14H8V10a2.0022 2.0022 0 012-2h4v2H10z"
});

var _ref457 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z"
});

var Intersect20 = /*#__PURE__*/React.forwardRef(function Intersect20(_ref455, ref) {
  var children = _ref455.children,
      rest = _objectWithoutProperties(_ref455, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref456, _ref457, children);
});

var _ref459 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 24H18V22h4V18h2v4A2.0021 2.0021 0 0122 24zM10 14H8V10a2.0022 2.0022 0 012-2h4v2H10z"
});

var _ref460 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z"
});

var Intersect16 = /*#__PURE__*/React.forwardRef(function Intersect16(_ref458, ref) {
  var children = _ref458.children,
      rest = _objectWithoutProperties(_ref458, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref459, _ref460, children);
});

var _ref462 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 24H23V28H19zM26 24H30V28H26zM19 17H23V21H19zM26 17H30V21H26z"
});

var _ref463 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
});

var InventoryManagement32 = /*#__PURE__*/React.forwardRef(function InventoryManagement32(_ref461, ref) {
  var children = _ref461.children,
      rest = _objectWithoutProperties(_ref461, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref462, _ref463, children);
});

var _ref465 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 24H23V28H19zM26 24H30V28H26zM19 17H23V21H19zM26 17H30V21H26z"
});

var _ref466 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
});

var InventoryManagement24 = /*#__PURE__*/React.forwardRef(function InventoryManagement24(_ref464, ref) {
  var children = _ref464.children,
      rest = _objectWithoutProperties(_ref464, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref465, _ref466, children);
});

var _ref468 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 24H23V28H19zM26 24H30V28H26zM19 17H23V21H19zM26 17H30V21H26z"
});

var _ref469 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
});

var InventoryManagement20 = /*#__PURE__*/React.forwardRef(function InventoryManagement20(_ref467, ref) {
  var children = _ref467.children,
      rest = _objectWithoutProperties(_ref467, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref468, _ref469, children);
});

var _ref471 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 24H23V28H19zM26 24H30V28H26zM19 17H23V21H19zM26 17H30V21H26z"
});

var _ref472 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
});

var InventoryManagement16 = /*#__PURE__*/React.forwardRef(function InventoryManagement16(_ref470, ref) {
  var children = _ref470.children,
      rest = _objectWithoutProperties(_ref470, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref471, _ref472, children);
});

var _ref474 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
});

var _ref475 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
});

var IotConnect32 = /*#__PURE__*/React.forwardRef(function IotConnect32(_ref473, ref) {
  var children = _ref473.children,
      rest = _objectWithoutProperties(_ref473, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref474, _ref475, children);
});

var _ref477 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
});

var _ref478 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
});

var IotConnect24 = /*#__PURE__*/React.forwardRef(function IotConnect24(_ref476, ref) {
  var children = _ref476.children,
      rest = _objectWithoutProperties(_ref476, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref477, _ref478, children);
});

var _ref480 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
});

var _ref481 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
});

var IotConnect20 = /*#__PURE__*/React.forwardRef(function IotConnect20(_ref479, ref) {
  var children = _ref479.children,
      rest = _objectWithoutProperties(_ref479, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref480, _ref481, children);
});

var _ref483 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
});

var _ref484 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
});

var IotConnect16 = /*#__PURE__*/React.forwardRef(function IotConnect16(_ref482, ref) {
  var children = _ref482.children,
      rest = _objectWithoutProperties(_ref482, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref483, _ref484, children);
});

var _ref486 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
});

var _ref487 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 21H11V11H21zm-8-2h6V13H13zM31 13H29A10.0117 10.0117 0 0019 3V1A12.0131 12.0131 0 0131 13z"
});

var _ref488 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z"
});

var IotPlatform32 = /*#__PURE__*/React.forwardRef(function IotPlatform32(_ref485, ref) {
  var children = _ref485.children,
      rest = _objectWithoutProperties(_ref485, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref486, _ref487, _ref488, children);
});

var _ref490 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
});

var _ref491 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 21H11V11H21zm-8-2h6V13H13zM31 13H29A10.0117 10.0117 0 0019 3V1A12.0131 12.0131 0 0131 13z"
});

var _ref492 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z"
});

var IotPlatform24 = /*#__PURE__*/React.forwardRef(function IotPlatform24(_ref489, ref) {
  var children = _ref489.children,
      rest = _objectWithoutProperties(_ref489, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref490, _ref491, _ref492, children);
});

var _ref494 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
});

var _ref495 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 21H11V11H21zm-8-2h6V13H13zM31 13H29A10.0117 10.0117 0 0019 3V1A12.0131 12.0131 0 0131 13z"
});

var _ref496 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z"
});

var IotPlatform20 = /*#__PURE__*/React.forwardRef(function IotPlatform20(_ref493, ref) {
  var children = _ref493.children,
      rest = _objectWithoutProperties(_ref493, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref494, _ref495, _ref496, children);
});

var _ref498 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
});

var _ref499 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 21H11V11H21zm-8-2h6V13H13zM31 13H29A10.0117 10.0117 0 0019 3V1A12.0131 12.0131 0 0131 13z"
});

var _ref500 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z"
});

var IotPlatform16 = /*#__PURE__*/React.forwardRef(function IotPlatform16(_ref497, ref) {
  var children = _ref497.children,
      rest = _objectWithoutProperties(_ref497, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref498, _ref499, _ref500, children);
});

var _ref502 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 23H24a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0128 23zM24 11V21h4V11zM18 23H12V21h6V17H14a2 2 0 01-2-2V11a2 2 0 012-2h6v2H14v4h4a2 2 0 012 2v4A2 2 0 0118 23zM2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z"
});

var Iso32 = /*#__PURE__*/React.forwardRef(function Iso32(_ref501, ref) {
  var children = _ref501.children,
      rest = _objectWithoutProperties(_ref501, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref502, children);
});

var _ref504 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 23H24a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0128 23zM24 11V21h4V11zM18 23H12V21h6V17H14a2 2 0 01-2-2V11a2 2 0 012-2h6v2H14v4h4a2 2 0 012 2v4A2 2 0 0118 23zM2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z"
});

var Iso24 = /*#__PURE__*/React.forwardRef(function Iso24(_ref503, ref) {
  var children = _ref503.children,
      rest = _objectWithoutProperties(_ref503, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref504, children);
});

var _ref506 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 23H24a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0128 23zM24 11V21h4V11zM18 23H12V21h6V17H14a2 2 0 01-2-2V11a2 2 0 012-2h6v2H14v4h4a2 2 0 012 2v4A2 2 0 0118 23zM2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z"
});

var Iso20 = /*#__PURE__*/React.forwardRef(function Iso20(_ref505, ref) {
  var children = _ref505.children,
      rest = _objectWithoutProperties(_ref505, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref506, children);
});

var _ref508 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 23H24a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0128 23zM24 11V21h4V11zM18 23H12V21h6V17H14a2 2 0 01-2-2V11a2 2 0 012-2h6v2H14v4h4a2 2 0 012 2v4A2 2 0 0118 23zM2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z"
});

var Iso16 = /*#__PURE__*/React.forwardRef(function Iso16(_ref507, ref) {
  var children = _ref507.children,
      rest = _objectWithoutProperties(_ref507, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref508, children);
});

var _ref510 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 13H24V19H21z"
});

var _ref511 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
});

var IsoFilled32 = /*#__PURE__*/React.forwardRef(function IsoFilled32(_ref509, ref) {
  var children = _ref509.children,
      rest = _objectWithoutProperties(_ref509, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref510, _ref511, children);
});

var _ref513 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 13H24V19H21z"
});

var _ref514 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
});

var IsoFilled24 = /*#__PURE__*/React.forwardRef(function IsoFilled24(_ref512, ref) {
  var children = _ref512.children,
      rest = _objectWithoutProperties(_ref512, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref513, _ref514, children);
});

var _ref516 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 13H24V19H21z"
});

var _ref517 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
});

var IsoFilled20 = /*#__PURE__*/React.forwardRef(function IsoFilled20(_ref515, ref) {
  var children = _ref515.children,
      rest = _objectWithoutProperties(_ref515, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref516, _ref517, children);
});

var _ref519 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 13H24V19H21z"
});

var _ref520 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
});

var IsoFilled16 = /*#__PURE__*/React.forwardRef(function IsoFilled16(_ref518, ref) {
  var children = _ref518.children,
      rest = _objectWithoutProperties(_ref518, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref519, _ref520, children);
});

var _ref522 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 21H21a2 2 0 01-2-2V13a2 2 0 012-2h3a2 2 0 012 2v6A2 2 0 0124 21zm-3-8v6h3V13zM15 21H10V19h5V17H12a2 2 0 01-2-2V13a2 2 0 012-2h5v2H12v2h3a2 2 0 012 2v2A2 2 0 0115 21zM6 11H8V21H6z"
});

var _ref523 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
});

var IsoOutline32 = /*#__PURE__*/React.forwardRef(function IsoOutline32(_ref521, ref) {
  var children = _ref521.children,
      rest = _objectWithoutProperties(_ref521, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref522, _ref523, children);
});

var _ref525 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 21H21a2 2 0 01-2-2V13a2 2 0 012-2h3a2 2 0 012 2v6A2 2 0 0124 21zm-3-8v6h3V13zM15 21H10V19h5V17H12a2 2 0 01-2-2V13a2 2 0 012-2h5v2H12v2h3a2 2 0 012 2v2A2 2 0 0115 21zM6 11H8V21H6z"
});

var _ref526 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
});

var IsoOutline24 = /*#__PURE__*/React.forwardRef(function IsoOutline24(_ref524, ref) {
  var children = _ref524.children,
      rest = _objectWithoutProperties(_ref524, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref525, _ref526, children);
});

var _ref528 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 21H21a2 2 0 01-2-2V13a2 2 0 012-2h3a2 2 0 012 2v6A2 2 0 0124 21zm-3-8v6h3V13zM15 21H10V19h5V17H12a2 2 0 01-2-2V13a2 2 0 012-2h5v2H12v2h3a2 2 0 012 2v2A2 2 0 0115 21zM6 11H8V21H6z"
});

var _ref529 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
});

var IsoOutline20 = /*#__PURE__*/React.forwardRef(function IsoOutline20(_ref527, ref) {
  var children = _ref527.children,
      rest = _objectWithoutProperties(_ref527, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref528, _ref529, children);
});

var _ref531 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 21H21a2 2 0 01-2-2V13a2 2 0 012-2h3a2 2 0 012 2v6A2 2 0 0124 21zm-3-8v6h3V13zM15 21H10V19h5V17H12a2 2 0 01-2-2V13a2 2 0 012-2h5v2H12v2h3a2 2 0 012 2v2A2 2 0 0115 21zM6 11H8V21H6z"
});

var _ref532 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
});

var IsoOutline16 = /*#__PURE__*/React.forwardRef(function IsoOutline16(_ref530, ref) {
  var children = _ref530.children,
      rest = _objectWithoutProperties(_ref530, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref531, _ref532, children);
});

var _ref534 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z"
});

var JoinInner32 = /*#__PURE__*/React.forwardRef(function JoinInner32(_ref533, ref) {
  var children = _ref533.children,
      rest = _objectWithoutProperties(_ref533, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref534, children);
});

var _ref536 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z"
});

var JoinInner24 = /*#__PURE__*/React.forwardRef(function JoinInner24(_ref535, ref) {
  var children = _ref535.children,
      rest = _objectWithoutProperties(_ref535, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref536, children);
});

var _ref538 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z"
});

var JoinInner20 = /*#__PURE__*/React.forwardRef(function JoinInner20(_ref537, ref) {
  var children = _ref537.children,
      rest = _objectWithoutProperties(_ref537, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref538, children);
});

var _ref540 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z"
});

var JoinInner16 = /*#__PURE__*/React.forwardRef(function JoinInner16(_ref539, ref) {
  var children = _ref539.children,
      rest = _objectWithoutProperties(_ref539, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref540, children);
});

var _ref542 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z"
});

var _ref543 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z"
});

var _ref544 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z",
  "data-icon-path": "inner-path"
});

var _ref545 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z"
});

var JoinLeft32 = /*#__PURE__*/React.forwardRef(function JoinLeft32(_ref541, ref) {
  var children = _ref541.children,
      rest = _objectWithoutProperties(_ref541, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref542, _ref543, _ref544, _ref545, children);
});

var _ref547 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z"
});

var _ref548 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z"
});

var _ref549 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z",
  "data-icon-path": "inner-path"
});

var _ref550 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z"
});

var JoinLeft24 = /*#__PURE__*/React.forwardRef(function JoinLeft24(_ref546, ref) {
  var children = _ref546.children,
      rest = _objectWithoutProperties(_ref546, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref547, _ref548, _ref549, _ref550, children);
});

var _ref552 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z"
});

var _ref553 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z"
});

var _ref554 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z",
  "data-icon-path": "inner-path"
});

var _ref555 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z"
});

var JoinLeft20 = /*#__PURE__*/React.forwardRef(function JoinLeft20(_ref551, ref) {
  var children = _ref551.children,
      rest = _objectWithoutProperties(_ref551, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref552, _ref553, _ref554, _ref555, children);
});

var _ref557 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z"
});

var _ref558 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z"
});

var _ref559 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z",
  "data-icon-path": "inner-path"
});

var _ref560 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z"
});

var JoinLeft16 = /*#__PURE__*/React.forwardRef(function JoinLeft16(_ref556, ref) {
  var children = _ref556.children,
      rest = _objectWithoutProperties(_ref556, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref557, _ref558, _ref559, _ref560, children);
});

var _ref562 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 6a9.9539 9.9539 0 00-4 .8379 9.9953 9.9953 0 010 18.3242A9.9988 9.9988 0 1020 6zM10 16a9.9976 9.9976 0 016-9.1621 10 10 0 100 18.3242A9.9976 9.9976 0 0110 16z"
});

var JoinOuter32 = /*#__PURE__*/React.forwardRef(function JoinOuter32(_ref561, ref) {
  var children = _ref561.children,
      rest = _objectWithoutProperties(_ref561, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref562, children);
});

var _ref564 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 6a9.9539 9.9539 0 00-4 .8379 9.9953 9.9953 0 010 18.3242A9.9988 9.9988 0 1020 6zM10 16a9.9976 9.9976 0 016-9.1621 10 10 0 100 18.3242A9.9976 9.9976 0 0110 16z"
});

var JoinOuter24 = /*#__PURE__*/React.forwardRef(function JoinOuter24(_ref563, ref) {
  var children = _ref563.children,
      rest = _objectWithoutProperties(_ref563, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref564, children);
});

var _ref566 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 6a9.9539 9.9539 0 00-4 .8379 9.9953 9.9953 0 010 18.3242A9.9988 9.9988 0 1020 6zM10 16a9.9976 9.9976 0 016-9.1621 10 10 0 100 18.3242A9.9976 9.9976 0 0110 16z"
});

var JoinOuter20 = /*#__PURE__*/React.forwardRef(function JoinOuter20(_ref565, ref) {
  var children = _ref565.children,
      rest = _objectWithoutProperties(_ref565, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref566, children);
});

var _ref568 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 6a9.9539 9.9539 0 00-4 .8379 9.9953 9.9953 0 010 18.3242A9.9988 9.9988 0 1020 6zM10 16a9.9976 9.9976 0 016-9.1621 10 10 0 100 18.3242A9.9976 9.9976 0 0110 16z"
});

var JoinOuter16 = /*#__PURE__*/React.forwardRef(function JoinOuter16(_ref567, ref) {
  var children = _ref567.children,
      rest = _objectWithoutProperties(_ref567, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref568, children);
});

var _ref570 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z"
});

var _ref571 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z",
  "data-icon-path": "inner-path"
});

var _ref572 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z"
});

var _ref573 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z"
});

var JoinRight32 = /*#__PURE__*/React.forwardRef(function JoinRight32(_ref569, ref) {
  var children = _ref569.children,
      rest = _objectWithoutProperties(_ref569, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref570, _ref571, _ref572, _ref573, children);
});

var _ref575 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z"
});

var _ref576 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z",
  "data-icon-path": "inner-path"
});

var _ref577 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z"
});

var _ref578 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z"
});

var JoinRight24 = /*#__PURE__*/React.forwardRef(function JoinRight24(_ref574, ref) {
  var children = _ref574.children,
      rest = _objectWithoutProperties(_ref574, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref575, _ref576, _ref577, _ref578, children);
});

var _ref580 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z"
});

var _ref581 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z",
  "data-icon-path": "inner-path"
});

var _ref582 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z"
});

var _ref583 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z"
});

var JoinRight20 = /*#__PURE__*/React.forwardRef(function JoinRight20(_ref579, ref) {
  var children = _ref579.children,
      rest = _objectWithoutProperties(_ref579, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref580, _ref581, _ref582, _ref583, children);
});

var _ref585 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z"
});

var _ref586 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z",
  "data-icon-path": "inner-path"
});

var _ref587 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z"
});

var _ref588 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z"
});

var JoinRight16 = /*#__PURE__*/React.forwardRef(function JoinRight16(_ref584, ref) {
  var children = _ref584.children,
      rest = _objectWithoutProperties(_ref584, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref585, _ref586, _ref587, _ref588, children);
});

var _ref590 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 23H4a2 2 0 01-2-2V19H4v2H8V9h2V21A2 2 0 018 23z"
});

var Jpg32 = /*#__PURE__*/React.forwardRef(function Jpg32(_ref589, ref) {
  var children = _ref589.children,
      rest = _objectWithoutProperties(_ref589, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref590, children);
});

var _ref592 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 23H4a2 2 0 01-2-2V19H4v2H8V9h2V21A2 2 0 018 23z"
});

var Jpg24 = /*#__PURE__*/React.forwardRef(function Jpg24(_ref591, ref) {
  var children = _ref591.children,
      rest = _objectWithoutProperties(_ref591, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref592, children);
});

var _ref594 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 23H4a2 2 0 01-2-2V19H4v2H8V9h2V21A2 2 0 018 23z"
});

var Jpg20 = /*#__PURE__*/React.forwardRef(function Jpg20(_ref593, ref) {
  var children = _ref593.children,
      rest = _objectWithoutProperties(_ref593, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref594, children);
});

var _ref596 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 23H4a2 2 0 01-2-2V19H4v2H8V9h2V21A2 2 0 018 23z"
});

var Jpg16 = /*#__PURE__*/React.forwardRef(function Jpg16(_ref595, ref) {
  var children = _ref595.children,
      rest = _objectWithoutProperties(_ref595, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref596, children);
});

var _ref598 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11zM21.3335 21h-2.667A1.6684 1.6684 0 0117 19.3335v-6.667A1.6684 1.6684 0 0118.6665 11h2.667A1.6684 1.6684 0 0123 12.6665v6.667A1.6684 1.6684 0 0121.3335 21zM19 19h2V13H19zM13.3335 21H9V19h4V17H11a2.002 2.002 0 01-2-2V12.6665A1.6684 1.6684 0 0110.6665 11H15v2H11v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0113.3335 21zM5.3335 21H2.6665A1.6684 1.6684 0 011 19.3335V17H3v2H5V11H7v8.3335A1.6684 1.6684 0 015.3335 21z"
});

var Json32 = /*#__PURE__*/React.forwardRef(function Json32(_ref597, ref) {
  var children = _ref597.children,
      rest = _objectWithoutProperties(_ref597, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref598, children);
});

var _ref600 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11zM21.3335 21h-2.667A1.6684 1.6684 0 0117 19.3335v-6.667A1.6684 1.6684 0 0118.6665 11h2.667A1.6684 1.6684 0 0123 12.6665v6.667A1.6684 1.6684 0 0121.3335 21zM19 19h2V13H19zM13.3335 21H9V19h4V17H11a2.002 2.002 0 01-2-2V12.6665A1.6684 1.6684 0 0110.6665 11H15v2H11v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0113.3335 21zM5.3335 21H2.6665A1.6684 1.6684 0 011 19.3335V17H3v2H5V11H7v8.3335A1.6684 1.6684 0 015.3335 21z"
});

var Json24 = /*#__PURE__*/React.forwardRef(function Json24(_ref599, ref) {
  var children = _ref599.children,
      rest = _objectWithoutProperties(_ref599, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref600, children);
});

var _ref602 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11zM21.3335 21h-2.667A1.6684 1.6684 0 0117 19.3335v-6.667A1.6684 1.6684 0 0118.6665 11h2.667A1.6684 1.6684 0 0123 12.6665v6.667A1.6684 1.6684 0 0121.3335 21zM19 19h2V13H19zM13.3335 21H9V19h4V17H11a2.002 2.002 0 01-2-2V12.6665A1.6684 1.6684 0 0110.6665 11H15v2H11v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0113.3335 21zM5.3335 21H2.6665A1.6684 1.6684 0 011 19.3335V17H3v2H5V11H7v8.3335A1.6684 1.6684 0 015.3335 21z"
});

var Json20 = /*#__PURE__*/React.forwardRef(function Json20(_ref601, ref) {
  var children = _ref601.children,
      rest = _objectWithoutProperties(_ref601, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref602, children);
});

var _ref604 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11zM21.3335 21h-2.667A1.6684 1.6684 0 0117 19.3335v-6.667A1.6684 1.6684 0 0118.6665 11h2.667A1.6684 1.6684 0 0123 12.6665v6.667A1.6684 1.6684 0 0121.3335 21zM19 19h2V13H19zM13.3335 21H9V19h4V17H11a2.002 2.002 0 01-2-2V12.6665A1.6684 1.6684 0 0110.6665 11H15v2H11v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0113.3335 21zM5.3335 21H2.6665A1.6684 1.6684 0 011 19.3335V17H3v2H5V11H7v8.3335A1.6684 1.6684 0 015.3335 21z"
});

var Json16 = /*#__PURE__*/React.forwardRef(function Json16(_ref603, ref) {
  var children = _ref603.children,
      rest = _objectWithoutProperties(_ref603, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref604, children);
});

var _ref606 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12zM21.3335 6h-2.667A1.6683 1.6683 0 0017 7.6665v6.667A1.6684 1.6684 0 0018.6665 16h2.667A1.6683 1.6683 0 0023 14.3335V7.6665A1.6683 1.6683 0 0021.3335 6zM21 14H19V8h2zM9 7.6665V10a2.002 2.002 0 002 2h2v2H9v2h4.3335A1.6683 1.6683 0 0015 14.3335V12a2.002 2.002 0 00-2-2H11V8h4V6H10.6665A1.6683 1.6683 0 009 7.6665zM5 14H3V12H1v2.3335A1.6684 1.6684 0 002.6665 16h2.667A1.6683 1.6683 0 007 14.3335V6H5z"
});

var JsonReference32 = /*#__PURE__*/React.forwardRef(function JsonReference32(_ref605, ref) {
  var children = _ref605.children,
      rest = _objectWithoutProperties(_ref605, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref606, children);
});

var _ref608 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12zM21.3335 6h-2.667A1.6683 1.6683 0 0017 7.6665v6.667A1.6684 1.6684 0 0018.6665 16h2.667A1.6683 1.6683 0 0023 14.3335V7.6665A1.6683 1.6683 0 0021.3335 6zM21 14H19V8h2zM9 7.6665V10a2.002 2.002 0 002 2h2v2H9v2h4.3335A1.6683 1.6683 0 0015 14.3335V12a2.002 2.002 0 00-2-2H11V8h4V6H10.6665A1.6683 1.6683 0 009 7.6665zM5 14H3V12H1v2.3335A1.6684 1.6684 0 002.6665 16h2.667A1.6683 1.6683 0 007 14.3335V6H5z"
});

var JsonReference24 = /*#__PURE__*/React.forwardRef(function JsonReference24(_ref607, ref) {
  var children = _ref607.children,
      rest = _objectWithoutProperties(_ref607, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref608, children);
});

var _ref610 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12zM21.3335 6h-2.667A1.6683 1.6683 0 0017 7.6665v6.667A1.6684 1.6684 0 0018.6665 16h2.667A1.6683 1.6683 0 0023 14.3335V7.6665A1.6683 1.6683 0 0021.3335 6zM21 14H19V8h2zM9 7.6665V10a2.002 2.002 0 002 2h2v2H9v2h4.3335A1.6683 1.6683 0 0015 14.3335V12a2.002 2.002 0 00-2-2H11V8h4V6H10.6665A1.6683 1.6683 0 009 7.6665zM5 14H3V12H1v2.3335A1.6684 1.6684 0 002.6665 16h2.667A1.6683 1.6683 0 007 14.3335V6H5z"
});

var JsonReference20 = /*#__PURE__*/React.forwardRef(function JsonReference20(_ref609, ref) {
  var children = _ref609.children,
      rest = _objectWithoutProperties(_ref609, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref610, children);
});

var _ref612 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12zM21.3335 6h-2.667A1.6683 1.6683 0 0017 7.6665v6.667A1.6684 1.6684 0 0018.6665 16h2.667A1.6683 1.6683 0 0023 14.3335V7.6665A1.6683 1.6683 0 0021.3335 6zM21 14H19V8h2zM9 7.6665V10a2.002 2.002 0 002 2h2v2H9v2h4.3335A1.6683 1.6683 0 0015 14.3335V12a2.002 2.002 0 00-2-2H11V8h4V6H10.6665A1.6683 1.6683 0 009 7.6665zM5 14H3V12H1v2.3335A1.6684 1.6684 0 002.6665 16h2.667A1.6683 1.6683 0 007 14.3335V6H5z"
});

var JsonReference16 = /*#__PURE__*/React.forwardRef(function JsonReference16(_ref611, ref) {
  var children = _ref611.children,
      rest = _objectWithoutProperties(_ref611, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref612, children);
});

var _ref614 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z"
});

var JumpLink32 = /*#__PURE__*/React.forwardRef(function JumpLink32(_ref613, ref) {
  var children = _ref613.children,
      rest = _objectWithoutProperties(_ref613, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref614, children);
});

var _ref616 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z"
});

var JumpLink24 = /*#__PURE__*/React.forwardRef(function JumpLink24(_ref615, ref) {
  var children = _ref615.children,
      rest = _objectWithoutProperties(_ref615, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref616, children);
});

var _ref618 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z"
});

var JumpLink20 = /*#__PURE__*/React.forwardRef(function JumpLink20(_ref617, ref) {
  var children = _ref617.children,
      rest = _objectWithoutProperties(_ref617, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref618, children);
});

var _ref620 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z"
});

var JumpLink16 = /*#__PURE__*/React.forwardRef(function JumpLink16(_ref619, ref) {
  var children = _ref619.children,
      rest = _objectWithoutProperties(_ref619, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref620, children);
});

var _ref622 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
});

var _ref623 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z"
});

var KeepDry32 = /*#__PURE__*/React.forwardRef(function KeepDry32(_ref621, ref) {
  var children = _ref621.children,
      rest = _objectWithoutProperties(_ref621, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref622, _ref623, children);
});

var _ref625 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
});

var _ref626 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z"
});

var KeepDry24 = /*#__PURE__*/React.forwardRef(function KeepDry24(_ref624, ref) {
  var children = _ref624.children,
      rest = _objectWithoutProperties(_ref624, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref625, _ref626, children);
});

var _ref628 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
});

var _ref629 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z"
});

var KeepDry20 = /*#__PURE__*/React.forwardRef(function KeepDry20(_ref627, ref) {
  var children = _ref627.children,
      rest = _objectWithoutProperties(_ref627, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref628, _ref629, children);
});

var _ref631 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
});

var _ref632 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z"
});

var KeepDry16 = /*#__PURE__*/React.forwardRef(function KeepDry16(_ref630, ref) {
  var children = _ref630.children,
      rest = _objectWithoutProperties(_ref630, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref631, _ref632, children);
});

var _ref634 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z"
});

var _ref635 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 20H21V22H10zM6 12H8V14H6zM10 12H12V14H10zM14 12H16V14H14zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM14 16H16V18H14zM22 12H26V14H22zM22 16H26V18H22zM18 16H20V18H18zM23 20H26V22H23z"
});

var Keyboard32 = /*#__PURE__*/React.forwardRef(function Keyboard32(_ref633, ref) {
  var children = _ref633.children,
      rest = _objectWithoutProperties(_ref633, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref634, _ref635, children);
});

var _ref637 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z"
});

var _ref638 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 20H21V22H10zM6 12H8V14H6zM10 12H12V14H10zM14 12H16V14H14zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM14 16H16V18H14zM22 12H26V14H22zM22 16H26V18H22zM18 16H20V18H18zM23 20H26V22H23z"
});

var Keyboard24 = /*#__PURE__*/React.forwardRef(function Keyboard24(_ref636, ref) {
  var children = _ref636.children,
      rest = _objectWithoutProperties(_ref636, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref637, _ref638, children);
});

var _ref640 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z"
});

var _ref641 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 20H21V22H10zM6 12H8V14H6zM10 12H12V14H10zM14 12H16V14H14zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM14 16H16V18H14zM22 12H26V14H22zM22 16H26V18H22zM18 16H20V18H18zM23 20H26V22H23z"
});

var Keyboard20 = /*#__PURE__*/React.forwardRef(function Keyboard20(_ref639, ref) {
  var children = _ref639.children,
      rest = _objectWithoutProperties(_ref639, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref640, _ref641, children);
});

var _ref643 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z"
});

var _ref644 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 20H21V22H10zM6 12H8V14H6zM10 12H12V14H10zM14 12H16V14H14zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM14 16H16V18H14zM22 12H26V14H22zM22 16H26V18H22zM18 16H20V18H18zM23 20H26V22H23z"
});

var Keyboard16 = /*#__PURE__*/React.forwardRef(function Keyboard16(_ref642, ref) {
  var children = _ref642.children,
      rest = _objectWithoutProperties(_ref642, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref643, _ref644, children);
});

var _ref646 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 19H24V21H18zM18 15H30V17H18zM18 11H30V13H18zM14 21V19H9V17H7v2H2v2h8.2148a8.5914 8.5914 0 01-2.2159 3.9771A9.2731 9.2731 0 016.5521 23H4.3334a10.8553 10.8553 0 002.1451 3.2966A14.6584 14.6584 0 013 28.127L3.7021 30a16.42 16.42 0 004.2907-2.3362A16.4883 16.4883 0 0012.2979 30L13 28.127A14.664 14.664 0 019.5228 26.3 10.3132 10.3132 0 0012.2516 21zM11.1666 13H13.333L8.75 2H6.5832L2 13H4.1664L5 11h5.3335zM5.8331 9L7.6665 4.6 9.5 9z"
});

var Language32 = /*#__PURE__*/React.forwardRef(function Language32(_ref645, ref) {
  var children = _ref645.children,
      rest = _objectWithoutProperties(_ref645, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref646, children);
});

var _ref648 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 19H24V21H18zM18 15H30V17H18zM18 11H30V13H18zM14 21V19H9V17H7v2H2v2h8.2148a8.5914 8.5914 0 01-2.2159 3.9771A9.2731 9.2731 0 016.5521 23H4.3334a10.8553 10.8553 0 002.1451 3.2966A14.6584 14.6584 0 013 28.127L3.7021 30a16.42 16.42 0 004.2907-2.3362A16.4883 16.4883 0 0012.2979 30L13 28.127A14.664 14.664 0 019.5228 26.3 10.3132 10.3132 0 0012.2516 21zM11.1666 13H13.333L8.75 2H6.5832L2 13H4.1664L5 11h5.3335zM5.8331 9L7.6665 4.6 9.5 9z"
});

var Language24 = /*#__PURE__*/React.forwardRef(function Language24(_ref647, ref) {
  var children = _ref647.children,
      rest = _objectWithoutProperties(_ref647, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref648, children);
});

var _ref650 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 19H24V21H18zM18 15H30V17H18zM18 11H30V13H18zM14 21V19H9V17H7v2H2v2h8.2148a8.5914 8.5914 0 01-2.2159 3.9771A9.2731 9.2731 0 016.5521 23H4.3334a10.8553 10.8553 0 002.1451 3.2966A14.6584 14.6584 0 013 28.127L3.7021 30a16.42 16.42 0 004.2907-2.3362A16.4883 16.4883 0 0012.2979 30L13 28.127A14.664 14.664 0 019.5228 26.3 10.3132 10.3132 0 0012.2516 21zM11.1666 13H13.333L8.75 2H6.5832L2 13H4.1664L5 11h5.3335zM5.8331 9L7.6665 4.6 9.5 9z"
});

var Language20 = /*#__PURE__*/React.forwardRef(function Language20(_ref649, ref) {
  var children = _ref649.children,
      rest = _objectWithoutProperties(_ref649, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref650, children);
});

var _ref652 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 19H24V21H18zM18 15H30V17H18zM18 11H30V13H18zM14 21V19H9V17H7v2H2v2h8.2148a8.5914 8.5914 0 01-2.2159 3.9771A9.2731 9.2731 0 016.5521 23H4.3334a10.8553 10.8553 0 002.1451 3.2966A14.6584 14.6584 0 013 28.127L3.7021 30a16.42 16.42 0 004.2907-2.3362A16.4883 16.4883 0 0012.2979 30L13 28.127A14.664 14.664 0 019.5228 26.3 10.3132 10.3132 0 0012.2516 21zM11.1666 13H13.333L8.75 2H6.5832L2 13H4.1664L5 11h5.3335zM5.8331 9L7.6665 4.6 9.5 9z"
});

var Language16 = /*#__PURE__*/React.forwardRef(function Language16(_ref651, ref) {
  var children = _ref651.children,
      rest = _objectWithoutProperties(_ref651, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref652, children);
});

var _ref654 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z",
  transform: "translate(0 .005)"
});

var _ref655 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 26.005H30V28.005H2z"
});

var Laptop32 = /*#__PURE__*/React.forwardRef(function Laptop32(_ref653, ref) {
  var children = _ref653.children,
      rest = _objectWithoutProperties(_ref653, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref654, _ref655, children);
});

var _ref657 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z",
  transform: "translate(0 .005)"
});

var _ref658 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 26.005H30V28.005H2z"
});

var Laptop24 = /*#__PURE__*/React.forwardRef(function Laptop24(_ref656, ref) {
  var children = _ref656.children,
      rest = _objectWithoutProperties(_ref656, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref657, _ref658, children);
});

var _ref660 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z",
  transform: "translate(0 .005)"
});

var _ref661 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 26.005H30V28.005H2z"
});

var Laptop20 = /*#__PURE__*/React.forwardRef(function Laptop20(_ref659, ref) {
  var children = _ref659.children,
      rest = _objectWithoutProperties(_ref659, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref660, _ref661, children);
});

var _ref663 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z",
  transform: "translate(0 .005)"
});

var _ref664 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 26.005H30V28.005H2z"
});

var Laptop16 = /*#__PURE__*/React.forwardRef(function Laptop16(_ref662, ref) {
  var children = _ref662.children,
      rest = _objectWithoutProperties(_ref662, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref663, _ref664, children);
});

var _ref666 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,2H12A9.9842,9.9842,0,0,0,7.0349,20.6553C7.0249,20.7705,7,20.8818,7,21a3.9929,3.9929,0,0,0,2.9106,3.83A4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,3.9966,3.9966,0,0,0,2.93-2.88H20A10,10,0,0,0,20,2ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm9-3H14.8579a3.9841,3.9841,0,0,0-7.15-1.2637A7.99,7.99,0,0,1,12,4h8a8,8,0,0,1,0,16Z"
});

var Lasso32 = /*#__PURE__*/React.forwardRef(function Lasso32(_ref665, ref) {
  var children = _ref665.children,
      rest = _objectWithoutProperties(_ref665, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref666, children);
});

var _ref668 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,2H12A9.9842,9.9842,0,0,0,7.0349,20.6553C7.0249,20.7705,7,20.8818,7,21a3.9929,3.9929,0,0,0,2.9106,3.83A4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,3.9966,3.9966,0,0,0,2.93-2.88H20A10,10,0,0,0,20,2ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm9-3H14.8579a3.9841,3.9841,0,0,0-7.15-1.2637A7.99,7.99,0,0,1,12,4h8a8,8,0,0,1,0,16Z"
});

var Lasso24 = /*#__PURE__*/React.forwardRef(function Lasso24(_ref667, ref) {
  var children = _ref667.children,
      rest = _objectWithoutProperties(_ref667, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref668, children);
});
export { Home16, Home20, Home24, Home32, Hospital16, Hospital20, Hospital24, Hospital32, HospitalBed16, HospitalBed20, HospitalBed24, HospitalBed32, Hotel16, Hotel20, Hotel24, Hotel32, Hourglass16, Hourglass20, Hourglass24, Hourglass32, Html16, Html20, Html24, Html32, HtmlReference16, HtmlReference20, HtmlReference24, HtmlReference32, Http16, Http20, Http24, Http32, Humidity16, Humidity20, Humidity24, Humidity32, HumidityAlt16, HumidityAlt20, HumidityAlt24, HumidityAlt32, Hurricane16, Hurricane20, Hurricane24, Hurricane32, HybridNetworking16, HybridNetworking20, HybridNetworking24, HybridNetworking32, IbmCloud16, IbmCloud20, IbmCloud24, IbmCloud32, IbmSecurity16, IbmSecurity20, IbmSecurity24, IbmSecurity32, IceAccretion16, IceAccretion20, IceAccretion24, IceAccretion32, Idea16, Idea20, Idea24, Idea32, Identification16, Identification20, Identification24, Identification32, Image16, Image20, Image24, Image32, ImageMedical16, ImageMedical20, ImageMedical24, ImageMedical32, ImageReference16, ImageReference20, ImageReference24, ImageReference32, ImageSearch16, ImageSearch20, ImageSearch24, ImageSearch32, ImproveRelevance16, ImproveRelevance20, ImproveRelevance24, ImproveRelevance32, InProgress16, InProgress20, InProgress24, InProgress32, InProgressError16, InProgressError20, InProgressError24, InProgressError32, InProgressWarning16, InProgressWarning20, InProgressWarning24, InProgressWarning32, Incomplete16, Incomplete20, Incomplete24, Incomplete32, IncompleteCancel16, IncompleteCancel20, IncompleteCancel24, IncompleteCancel32, IncompleteError16, IncompleteError20, IncompleteError24, IncompleteError32, IncompleteWarning16, IncompleteWarning20, IncompleteWarning24, IncompleteWarning32, IncreaseLevel16, IncreaseLevel20, IncreaseLevel24, IncreaseLevel32, Industry16, Industry20, Industry24, Industry32, Information16, Information20, Information24, Information32, InformationFilled16, InformationFilled20, InformationFilled24, InformationFilled32, InformationSquare16, InformationSquare20, InformationSquare24, InformationSquare32, InformationSquareFilled16, InformationSquareFilled20, InformationSquareFilled24, InformationSquareFilled32, Insert16, Insert20, Insert24, Insert32, InsertPage16, InsertPage20, InsertPage24, InsertPage32, Integration16, Integration20, Integration24, Integration32, Interactions16, Interactions20, Interactions24, Interactions32, Intersect16, Intersect20, Intersect24, Intersect32, InventoryManagement16, InventoryManagement20, InventoryManagement24, InventoryManagement32, IotConnect16, IotConnect20, IotConnect24, IotConnect32, IotPlatform16, IotPlatform20, IotPlatform24, IotPlatform32, Iso16, Iso20, Iso24, Iso32, IsoFilled16, IsoFilled20, IsoFilled24, IsoFilled32, IsoOutline16, IsoOutline20, IsoOutline24, IsoOutline32, JoinInner16, JoinInner20, JoinInner24, JoinInner32, JoinLeft16, JoinLeft20, JoinLeft24, JoinLeft32, JoinOuter16, JoinOuter20, JoinOuter24, JoinOuter32, JoinRight16, JoinRight20, JoinRight24, JoinRight32, Jpg16, Jpg20, Jpg24, Jpg32, Json16, Json20, Json24, Json32, JsonReference16, JsonReference20, JsonReference24, JsonReference32, JumpLink16, JumpLink20, JumpLink24, JumpLink32, KeepDry16, KeepDry20, KeepDry24, KeepDry32, Keyboard16, Keyboard20, Keyboard24, Keyboard32, Language16, Language20, Language24, Language32, Laptop16, Laptop20, Laptop24, Laptop32, Lasso24, Lasso32, QID16, QID20, QID24, QID32, WatsonHealthHoleFillingCursor16, WatsonHealthHoleFillingCursor20, WatsonHealthHoleFillingCursor24, WatsonHealthHoleFillingCursor32, WatsonHealthICa_2D16, WatsonHealthICa_2D20, WatsonHealthICa_2D24, WatsonHealthICa_2D32, WatsonHealthInteractiveSegmentationCursor16, WatsonHealthInteractiveSegmentationCursor20, WatsonHealthInteractiveSegmentationCursor24, WatsonHealthInteractiveSegmentationCursor32 };